module.exports = __webpack_public_path__ + "static/media/16_l_truba1_0_19.91.1180a36d.png";